import React from "react";
import Image from "next/image";

export default function Team_Home_Layout5({ data }: { data: any }) {
  return (
    <section className="py-16 bg-[#F9F7F3]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <h2 className="text-3xl   text-center mb-16">{data.title}</h2>
        <div className="flex flex-wrap justify-center gap-12">
          {data.founders.map((founder: any) => (
            <div key={founder.id} className="text-center w-40">
              <div className="w-40 h-40 relative rounded-full overflow-hidden mx-auto mb-4 shadow-lg">
                <Image
                  src={founder.picture.data.attributes.url}
                  alt={founder.name}
                  fill
                  className="object-cover"
                />
              </div>
              <h3 className=" ">{founder.name}</h3>
              <p className="text-sm text-[#5A534A]">{founder.designation}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}